export default __webpack_public_path__ + "static/media/QCam_Icon-2.6325e4e5.png";